import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useEffect, useMemo, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { LetterEditor } from "@/components/letter-editor";
import { useEmrContext } from "@/hooks/emr-context";
import { useAutoPopulationFields, useCreateLetter, useLetterTemplateBody, useLetterTemplates, usePopulateLetter } from "@/hooks/letter";
import { usePatientReports } from "@/hooks/report";
import { usePatientDetails } from "@/hooks/patient";
import { useComposerStore } from "@/stores/composers";
import { useCompleteActionFromComposer } from "@/hooks/tasks";
import { formatDate } from "@/utils/format";
import { applyVariableValues, fileToDataUrl, processLetterForSave, resolveLetterImages, stripVariableValues, toLabelKeyedValues } from "@/utils/letter";
import { parseLetterComposerContent } from "./parse-composer-content";
import { ComposerShell } from "./composer-shell";
import { PreferredLanguage } from "./preferred-language";
import { LetterComposerFooter } from "./letter-composer-footer";
import { LetterComposerSelects } from "./letter-composer-selects";
/** Letter composer: pick a template + report, auto-populate, edit, preview, and send. */
export function LetterComposerBody(_ref) {
  var _parseLetterComposerC, _parseLetterComposerC2, _patientDetails$data$, _patientDetails$data, _templates$data, _reports$data, _find$name, _find, _templates$data2;
  var composer = _ref.composer;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useEmrContext = useEmrContext(),
    workspaceId = _useEmrContext.workspaceId,
    patientUid = _useEmrContext.patientUid;
  var close = useComposerStore(function (state) {
    return state.close;
  });
  var initTid = (_parseLetterComposerC = (_parseLetterComposerC2 = parseLetterComposerContent(composer.content)) === null || _parseLetterComposerC2 === void 0 ? void 0 : _parseLetterComposerC2.templateId) !== null && _parseLetterComposerC !== void 0 ? _parseLetterComposerC : composer.initialTemplateId;
  var _useState = useState(initTid != null ? String(initTid) : null),
    templateId = _useState[0],
    setTemplateId = _useState[1];
  var _useState2 = useState(null),
    reportId = _useState2[0],
    setReportId = _useState2[1];
  var _useState3 = useState(""),
    seedHtml = _useState3[0],
    setSeedHtml = _useState3[1];
  var _useState4 = useState(""),
    currentHtml = _useState4[0],
    setCurrentHtml = _useState4[1];
  var _useState5 = useState(null),
    error = _useState5[0],
    setError = _useState5[1];
  var _useState6 = useState(false),
    isPreparing = _useState6[0],
    setIsPreparing = _useState6[1];
  var _useState7 = useState(false),
    isPreview = _useState7[0],
    setIsPreview = _useState7[1];
  var templates = useLetterTemplates(workspaceId, true, "letter");
  var reports = usePatientReports(patientUid);
  var templateBody = useLetterTemplateBody(workspaceId, templateId ? Number(templateId) : null);
  var basePopulate = usePopulateLetter(workspaceId, patientUid);
  var reportPopulate = usePopulateLetter(workspaceId, patientUid, reportId ? Number(reportId) : undefined);
  var autoFields = useAutoPopulationFields(workspaceId);
  var createLetter = useCreateLetter(patientUid);
  var completeAction = useCompleteActionFromComposer(composer.actionMeta);
  var patientDetails = usePatientDetails(workspaceId, patientUid, {
    enabled: false
  });
  var preferredLanguages = (_patientDetails$data$ = (_patientDetails$data = patientDetails.data) === null || _patientDetails$data === void 0 || (_patientDetails$data = _patientDetails$data.basic_info) === null || _patientDetails$data === void 0 ? void 0 : _patientDetails$data.languages) !== null && _patientDetails$data$ !== void 0 ? _patientDetails$data$ : [];
  var templateOptions = ((_templates$data = templates.data) !== null && _templates$data !== void 0 ? _templates$data : []).map(function (item) {
    return {
      value: String(item.id),
      label: item.name
    };
  });
  var reportOptions = ((_reports$data = reports.data) !== null && _reports$data !== void 0 ? _reports$data : []).map(function (item) {
    return {
      value: String(item.id),
      label: [item.heading, item.updated_at ? formatDate(item.updated_at) : null].filter(Boolean).join(" · ")
    };
  });
  var variableValues = useMemo(function () {
    var _basePopulate$data, _reportPopulate$data, _autoFields$data;
    return toLabelKeyedValues(_objectSpread(_objectSpread({}, (_basePopulate$data = basePopulate.data) !== null && _basePopulate$data !== void 0 ? _basePopulate$data : {}), (_reportPopulate$data = reportPopulate.data) !== null && _reportPopulate$data !== void 0 ? _reportPopulate$data : {}), (_autoFields$data = autoFields.data) !== null && _autoFields$data !== void 0 ? _autoFields$data : []);
  }, [basePopulate.data, reportPopulate.data, autoFields.data]);
  var variableValuesRef = useRef(variableValues);
  variableValuesRef.current = variableValues;
  useEffect(function () {
    var _templateBody$data;
    var body = (_templateBody$data = templateBody.data) === null || _templateBody$data === void 0 ? void 0 : _templateBody$data.template;
    if (!body) return undefined;
    var active = true;
    setIsPreparing(true);
    resolveLetterImages(body, workspaceId).then(function (resolved) {
      if (active) setSeedHtml(applyVariableValues(resolved, variableValuesRef.current));
    })["finally"](function () {
      if (active) setIsPreparing(false);
    });
    return function () {
      active = false;
    };
  }, [templateBody.data, workspaceId]);
  var templateName = (_find$name = (_find = ((_templates$data2 = templates.data) !== null && _templates$data2 !== void 0 ? _templates$data2 : []).find(function (item) {
    return String(item.id) === templateId;
  })) === null || _find === void 0 ? void 0 : _find.name) !== null && _find$name !== void 0 ? _find$name : t("letter", {
    defaultValue: "Letter"
  });
  var send = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var stripped, letter, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            setError(null);
            _context.p = 1;
            stripped = stripVariableValues(currentHtml || seedHtml);
            _context.n = 2;
            return processLetterForSave(stripped, workspaceId);
          case 2:
            letter = _context.v;
            _context.n = 3;
            return createLetter.mutateAsync({
              letter: letter,
              title: templateName,
              letter_template_id: templateId ? Number(templateId) : 0
            });
          case 3:
            completeAction();
            close(composer.id);
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            setError(t("letter_save_failed", {
              defaultValue: "Could not save the letter. Please try again."
            }));
          case 5:
            return _context.a(2);
        }
      }, _callee, null, [[1, 4]]);
    }));
    return function send() {
      return _ref2.apply(this, arguments);
    };
  }();
  var hasContent = Boolean((currentHtml || seedHtml).trim());
  var canSend = hasContent && Boolean(templateId);
  var handleTemplateChange = function handleTemplateChange(value) {
    setTemplateId(value);
    if (!value) {
      setSeedHtml("");
      setCurrentHtml("");
      setIsPreview(false);
    }
  };
  return /*#__PURE__*/React.createElement(ComposerShell, {
    composerId: composer.id,
    title: composer.title,
    subtitle: composer.subtitle,
    wide: true,
    fullHeight: true,
    footer: /*#__PURE__*/React.createElement(LetterComposerFooter, {
      composerId: composer.id,
      hasContent: hasContent,
      isPreview: isPreview,
      isSaving: createLetter.isLoading,
      canSend: canSend,
      onTogglePreview: function onTogglePreview() {
        return setIsPreview(function (value) {
          return !value;
        });
      },
      onCancel: function onCancel() {
        return close(composer.id);
      },
      onSend: function onSend() {
        return void send();
      }
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col gap-4"
  }, /*#__PURE__*/React.createElement(LetterComposerSelects, {
    composerId: composer.id,
    templateOptions: templateOptions,
    reportOptions: reportOptions,
    templateId: templateId,
    reportId: reportId,
    lockTemplate: Boolean(composer.lockTemplate),
    isPreview: isPreview,
    templatesLoading: templates.isLoading,
    reportsLoading: reports.isLoading,
    onTemplateChange: handleTemplateChange,
    onReportChange: setReportId
  }), /*#__PURE__*/React.createElement(PreferredLanguage, {
    languages: preferredLanguages
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex min-h-0 flex-1 flex-col rounded-sds-200 border border-sds-base-default p-3"
  }, isPreparing ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-base-tertiary"
  }, t("loading", {
    defaultValue: "Loading…"
  })) : /*#__PURE__*/React.createElement(LetterEditor, {
    value: seedHtml,
    onChange: setCurrentHtml,
    readOnly: isPreview,
    onImageFile: fileToDataUrl,
    variableValues: variableValues,
    placeholder: t("letter_placeholder", {
      defaultValue: "Write the letter…"
    })
  })), error ? /*#__PURE__*/React.createElement("p", {
    className: "text-style-body-small text-sds-urgent-secondary"
  }, error) : null));
}